<template>
	<div class="candy" v-if="p_candy">
		<div class="candy-image">
			<img :src="this.$root.d_get_url_candy_images + this.p_candy.strMCode + '.png?v=' + this.$root.d_get_date_version_cache" class="img-responsive hidden-xs">
			<img :src="this.$root.d_get_url_candy_images + this.p_candy.strMCode + '_xs.png?v=' + this.$root.d_get_date_version_cache" class="img-responsive visible-xs">
			<div class="candy-image-title">
				<div class="candy-image-title-icon">
					<div class="middle">
						<img :src="this.$root.d_get_url_candys + 'images/icon-experiencia-2_' + this.p_candy.strMCode + '.png?v=' + this.$root.d_get_date_version_cache" class="img-responsive">
					</div>
				</div>
				<div class="candy-image-title-text">
					<div class="middle">
						<span v-html="m_replace_text(p_candy.strTitle)"></span>
					</div>
				</div>
				<div class="clear"></div>
			</div>
		</div>
		<div class="candy-information">
			<div class="candy-information-description">
				<span>{{ p_candy.strDescription }}</span>
			</div>
			<div class="candy-information-properties" v-if="c_get_candy_properties">
				<div v-for="(property, index) in c_get_candy_properties" class="candy-property">
					<template v-if="property.clave == 'Salas'">
						<span class="salas">{{ property.clave }}:</span>
						<span v-for="(valor, index) in property.valores" class="formato" :class="'sala-' + valor.toLowerCase()" v-html="valor"></span>
					</template>
					<template v-else-if="property.clave == 'Incluye'">
						<div class="candy-property-clave">
							<span>{{ property.clave }}:</span>
						</div>
						<div class="candy-property-valores">
							<template v-for="(valor, index) in property.valores">
								<div v-if="index == 0" class="valor entradas">
									<span v-html="valor"></span>
								</div>
								<div v-else-if="index == 1" class="valor pochoclos">
									<span v-html="valor"></span>
								</div>
								<div v-else-if="index == 2" class="valor gaseosa">
									<span v-html="valor"></span>
								</div>
								<div v-else class="valor golosina">
									<span v-html="valor"></span>
								</div>
							</template>
						</div>
					</template>
					<template v-else-if="property.clave == 'Cines'">
						<span class="cines">{{ property.clave }}:</span>
						<span v-for="(valor, index) in property.valores" class="nombre" v-html="index == 0 ? valor : ', ' + valor"></span>
					</template>
				</div>
			</div>
		</div>
		<div class="candy-options">
			<div class="candy-options-title">
				<span>AGREGÁ AL CARRITO</span>
			</div>
			<div class="candy-discount">
				<span v-html="c_product_discount_msge"></span>
			</div>
			<div class="candy-options-items">
				<template v-for="(option, index) in p_candy.BuyOptions" :key="index">
					<v-buyoption :p_candy="p_candy" :p_buyoption="option"></v-buyoption>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import $ from "jquery";
import moment from "moment";
import BuyOption from "./BuyOption.vue";

export default {
	name: 'candyticket',
	components: {
		"v-buyoption": BuyOption
	},
	props: {
		p_candy: { type: Object, default: () => null }
	},
	computed: {
		c_get_candy_properties() {
			var candy_properties = null;

			if (this.$root.d_candys_properties) {
				this.$root.d_candys_properties.forEach(candypropery => {
					if (candypropery.strMocode == this.p_candy.strMCode) {
						candy_properties = candypropery.properties;
					}
				});
			}

			return candy_properties;
		},
		c_product_discount_msge: function () {
			var message = "";

			var productMsgs = this.$root.d_get_discount_product_msgs.split(';;');

			productMsgs.forEach(productMsg => {
				var productMsgList = productMsg.split('--');

				if (productMsgList[0] != '' & productMsgList[0] == this.p_candy.strMCode) {
					message = productMsgList[1];
				}
			});

			return message;
		}
	},
	methods: {
		m_replace_text: function (text) {
			var replaced = false;

			var modifiedText = text.replace(" ", function (match) {
				if (!replaced) {
					replaced = true;
					return "<br>";
				} else {
					return match;
				}
			});

			modifiedText = modifiedText.replace("EXPERIENCIA", "<small>EXPERIENCIA</small>");

			return modifiedText;
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/CandyTicket.vue